export default __webpack_public_path__ + "static/media/supplier_invoice_guide.31d51002.pdf";